import { Component, OnInit, Input } from '@angular/core';
import { AuthService } from '../../../../shared';
import { Router } from '@angular/router';
import { GaService, ProductService } from '../../../../services';

@Component({
  selector: 'app-my-navigation',
  templateUrl: './my-navigation.component.html',
  styleUrls: ['./my-navigation.component.scss'],
})
export class MyNavigationComponent implements OnInit {
  @Input() currentPage: string;

  constructor(
    private router: Router,
    private authService: AuthService,
    private gaService: GaService,
    private productService: ProductService
  ) {}

  ngOnInit() {}

  signout() {
    this.authService.signout();
    this.productService.selectProducts = [];
    this.gaService.MOJI_Logout();
    this.router.navigate(['/signin']);
  }
}
